import type { Tenant } from "@albertine/tenant-config";

export type DesignSystemTenant = Tenant | "carlo";

const tenantCssLoaders = import.meta.glob("../../available-tokens/*.css", {
    query: "?inline",
    import: "default",
});
let latestTenantCssRequest = 0;

/**
 * Loads tenant-specific design token CSS via Vite and keeps exactly one active
 * tenant stylesheet on the page.
 */
export async function loadTenantCSS(tenant: DesignSystemTenant): Promise<void> {
    const request = latestTenantCssRequest + 1;

    latestTenantCssRequest = request;

    const cssPath = `../../available-tokens/${tenant}.css`;
    const loadCss = tenantCssLoaders[cssPath];

    if (loadCss === undefined) {
        throw new Error(`No design token CSS found for tenant "${tenant}".`);
    }

    const css = (await loadCss()) as string;

    if (request !== latestTenantCssRequest) {
        return;
    }

    const selector = "style[data-albertine-tenant-css]";
    const existingStyle = document.querySelector<HTMLStyleElement>(selector);
    const tenantStyle = existingStyle ?? document.createElement("style");

    tenantStyle.dataset.albertineTenantCss = tenant;
    tenantStyle.textContent = css;
    document.head.append(tenantStyle);
}
